import * as React from 'react';
import { UIText2 } from '@cian/ui-kit';
import { IExpiredProps } from './types';

export const Expired = (props: IExpiredProps) => {
  const { onLinkClick } = props;

  return (
    <>
      <UIText2 display="inline" color="gray60_100">
        Если хотите разместить объект с&nbsp;другим адресом,
      </UIText2>
      &nbsp;
      <a href="/razmestit-obyavlenie/" target="_blank" onClick={onLinkClick} data-testid="newOfferLink">
        создайте новое объявление
      </a>
    </>
  );
};
